module.exports = __webpack_public_path__ + "static/img/far1.3d88d82b.png";